import { Text } from '@/components/text';
import { useAuthStore } from '@/stores/auth-store';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

interface UserMenuContentProps {
  onLogout: () => Promise<void>;
}

export function UserMenuContent({ onLogout }: UserMenuContentProps) {
  const { user } = useAuthStore();
  const { t } = useTranslation();

  return (
    <View style={styles.menuContainer}>
      <View style={styles.menuHeader}>
        <Text style={styles.userEmail}>{user?.email}</Text>
      </View>
      <View style={styles.divider} />

      <TouchableOpacity style={styles.menuItem} onPress={onLogout}>
        <Ionicons name='log-out-outline' size={20} color='#FF3B30' />
        <Text style={styles.logoutText}>{t('auth.logout', 'Log out')}</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  menuContainer: {
    padding: 8,
  },
  menuHeader: {
    padding: 12,
  },
  userEmail: {
    fontSize: 14,
    color: '#333',
    fontWeight: '500',
  },
  divider: {
    height: 1,
    backgroundColor: '#f0f0f0',
    marginVertical: 4,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12,
    gap: 8,
    borderRadius: 8,
  },
  logoutText: {
    color: '#FF3B30',
    fontSize: 14,
    fontWeight: '500',
  },
});
